import Splitting from 'splitting';

export default () => {
    const headings = document.querySelectorAll('.wysiwyg-scroll-heading');

    headings.forEach((heading) => {
        const results = Splitting({
            target: heading,
            by: 'chars',
            whitespace: true,
        });

        const chars = results[0].chars;

        const trackScrollProgress = () => {
            const rect = heading.getBoundingClientRect();
            const viewportHeight = window.innerHeight;

            // Define boundaries
            const startPoint = viewportHeight - 200;
            const endPoint = viewportHeight / 2;

            // Calculate progress based on element position
            // Start when top of element reaches startPoint (0%)
            // End when bottom of element reaches endPoint (100%)
            const totalDistance = startPoint - endPoint + rect.height;
            const currentPosition = startPoint - rect.top;

            // Calculate progress percentage (clamped between 0 and 1)
            let progress = currentPosition / totalDistance;
            progress = Math.max(0, Math.min(1, progress));

            // Update custom property
            heading.style.setProperty('--scroll-progress', progress);

            // Calculate how many characters should be active
            const activeCount = Math.ceil(chars.length * progress);

            // Update active state for each character
            chars.forEach((char, index) => {
                if (index < activeCount) {
                    char.classList.add('is-active');
                } else {
                    char.classList.remove('is-active');
                }
            });
        };

        // Use requestAnimationFrame for better performance
        let ticking = false;
        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    trackScrollProgress();
                    ticking = false;
                });
                ticking = true;
            }
        });

        trackScrollProgress();
    });
};
